<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <form>
              <div class="card-body__form">
                <div class="row">
                  <div class="col-lg-6">
                    <!-- Information Title -->
                    <div class="form-group">
                      <label for="informationTitle">العنوان</label>
                      <input
                        type="text"
                        class="form-control"
                        id="informationTitle"
                        placeholder="العنوان"
                        required
                        readonly
                        :value="information.title"
                      />
                    </div>
                    <!-- Information Image -->
                    <div class="from-group">
                      <label for="">صورة الخبر</label>
                      <div
                        class="img-container mt-2"
                        v-if="information.thumbnail_url"
                      >
                        <img
                          :src="information.thumbnail_url"
                          class="img-fluid"
                          alt="information image"
                        />
                      </div>
                      <div class="img__container mt-2" v-else>
                        <span>لا توجد صورة</span>
                      </div>
                    </div>
                  </div>
                  <!-- Information Data -->
                  <div class="col-lg-6">
                    <!-- Short Description -->
                    <div class="form-group">
                      <label for="title">وصف قصير</label>
                      <textarea
                        class="form-control"
                        placeholder="وصف قصير"
                        id="title"
                        cols="30"
                        :value="information.short_description"
                        rows="6"
                        readonly
                      ></textarea>
                    </div>
                    <!-- Full Description -->
                    <div class="form-group">
                      <label for="">المحتوى</label>
                      <div class="mt-2">
                        <!-- Text -->
                        <div
                          v-if="information.information_type == 1"
                          v-html="information.description"
                        ></div>
                        <!-- Image -->
                        <div
                          v-if="information.information_type == 2"
                          class="img-container"
                        >
                          <img
                            :src="information.file_url"
                            class="img-fluid"
                            alt="information image"
                          />
                        </div>
                        <!-- File -->
                        <div
                          v-if="information.information_type == 3"
                          class="file__container"
                        >
                          <a :href="information.file_url"> لرؤيت الملف </a>
                        </div>
                        <!-- Video -->
                        <div
                          v-if="information.information_type == 4"
                          class="file__container"
                        >
                          <a :href="information.file_url"> لرؤيت الفيديو </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      information_id: this.$route.params.id,
      isloading: true,
      information: {},
    };
  },
  methods: {
    ...mapActions("informationsModule", ["getInformationById"]),
  },
  async created() {
    this.information = await this.getInformationById(this.information_id);
    console.log("information", this.information);
  },
  computed: {
    ...mapGetters("informationsModule", ["isLoading"]),
  },
  mounted() {
    this.isloading = this.isLoading;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>

<style lang="scss" >
</style>